import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Service for changing the user's password.
 *
 * This service provides a method to change the user's password by sending a request to the server.
 * It includes the necessary headers and body for the request.
 * The service uses Angular's HttpClient to make the HTTP request.
 *
 * ### How It Works:
 * - The `changePassword` method takes the current password, new password, and confirmation of the new password as parameters.
 * - It retrieves the authentication token from local storage and sets it in the request headers.
 * - The method sends a POST request to the server with the password change details.    
 */
@Injectable({ providedIn: 'root' })
export class PasswordChangeService {
    /** URL for fetching scan configurations */
    updatePasswordUrl = environment.apiUrl + '/Authentication/UpdatePassword'

    constructor(private http: HttpClient) { }

    changePassword(
        currentPassword: string,
        newPassword: string,
        newPasswordConfirm: string
    ): Observable<any> {

        const jsonObj = JSON.parse(localStorage.getItem('authentication')!);
        if (!jsonObj) {
            throw new Error('No authentication data found in local storage');
        }
        const token = jsonObj.token;
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        };

        const body = {
            oldPassword: currentPassword,
            newPassword: newPassword,
            confirmNewPassword: newPasswordConfirm
        };

        return this.http.post(this.updatePasswordUrl, body, { headers });

    }
}